import { DWT_PAYLOAD_STATUS_CODE_TO_FILTER_LABEL } from '../dwt-payloads/dwt-payloads.constants';
import { DWT_DEFRA_SUBMISSION_STATUS_CODES } from './dwt-defra-submissions.constants';

/** Successful / Warnings / Errors — all selected by default. */
export const DWT_DEFRA_SUBMISSIONS_STATUS_MULTISELECT_OPTIONS: readonly {
    value: string;
    label: string;
}[] = DWT_DEFRA_SUBMISSION_STATUS_CODES.map((code) => ({
    value: String(code),
    label: DWT_PAYLOAD_STATUS_CODE_TO_FILTER_LABEL[code],
}));
